import clsx from "clsx";

import Loader from "@/ui/atoms/Loader";

import type { LayoutFullScreenProps } from "@/ui/layouts/LayoutFullScreen";
import LayoutFullScreen from "@/ui/layouts/LayoutFullScreen";
import LayoutFillParentCentered from "@/ui/layouts/LayoutFillParentCentered";

export type FullScreenAuthLoaderProps = LayoutFullScreenProps & {
    label: string;
};

const testId = "FullScreenAuthLoader";
const FullScreenAuthLoader = (props: FullScreenAuthLoaderProps) => {
    const { sx, className, label, ...otherProps } = props;

    return (
        <LayoutFullScreen
            data-testid={testId}
            className={clsx([testId, className])}
            sx={{
                ...sx,
            }}
            {...otherProps}
        >
            <LayoutFillParentCentered
                sx={{
                    backgroundColor: "white",
                }}
            >
                <Loader label={label} />
            </LayoutFillParentCentered>
        </LayoutFullScreen>
    );
};

export default FullScreenAuthLoader;
